import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Donutchart from '../../common/donutchart';
import Linechart from '../../common/linechart';


const Attendess = () => {

    const [isSearchbar, toggleSearchBar] = useState(false);

    return (
        <>
            <div className={`overlay ${isSearchbar ? 'active' : ''}`} onClick={() => toggleSearchBar(false)}></div>
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>All Events</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/events/admin/">Amasi</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">All Events</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-1 col-sm-12 text-right hidden-xs"></div>
                        <div className="col-md-5 col-sm-12 text-right">
                            <div className="input-group mb-3">
                                <div className='search_input_div_event'>
                                    <input type="text" className="form-control" placeholder="Search here..." />
                                    <span onClick={() => toggleSearchBar(true)} className="btn btn-outline-primary mr-1" title="">Create an Event</span>
                                </div>
                            </div>
                        </div>
                    </div>
           
                </div>
            </div>
        </>
    );
}
export default Attendess;
